import React, { createContext, useState, Dispatch } from 'react';

interface ProviderProps {
  children: JSX.Element;
}

export interface TestCandidates {
  examNo: string;
  regNo: string;
  surname: string;
  firstName: string;
  email: string;
  phone: string;
  gender: string;
  registeredCourse: string;
}

export interface CandidateData extends TestCandidates {
  userId: number;
  name: null | number;
  candidateNumber: string;
  category: string;
  status: string;
  pictureUrl: null | string;
  isFirstLogin: boolean;
  isActive: false;
}

export interface CandidateDetails {
  PeriodId: number;
  CategoryId: number;
  InstitutionId: number;
  Candidates: Array<TestCandidates>;
}

export interface CandidateCategory {
  categoryId: number;
  category: string;
  period: string;
  periodId: number;
  candidateCount: number;
}

interface ContextValues {
  candidateData: CandidateDetails;
  setCandidateData: Dispatch<React.SetStateAction<CandidateDetails>>;
  candidateCategory: CandidateCategory;
  setCandidateCategory: Dispatch<React.SetStateAction<CandidateCategory>>;
}

const defaultValue = {
  candidateCategory: {
    categoryId: 0,
    category: 'string',
    period: 'string',
    periodId: 0,
    candidateCount: 0,
  },
  candidateData: {
    PeriodId: 0,
    CategoryId: 0,
    InstitutionId: 0,
    Candidates: [
      {
        examNo: '',
        regNo: '',
        surname: '',
        firstName: '',
        email: '',
        phone: '',
        gender: '',
        registeredCourse: '',
      },
    ],
  },

  setCandidateCategory: function (
    value: React.SetStateAction<CandidateCategory>
  ): void {
    value;
    throw new Error('Function not implemented.');
  },
  setCandidateData: function (
    value: React.SetStateAction<CandidateDetails>
  ): void {
    value;
    throw new Error('Function not implemented.');
  },
};

export const CandidateContext = createContext<ContextValues>(defaultValue);

export const CandidateProvider = ({ children }: ProviderProps) => {
  const [candidateData, setCandidateData] = useState<CandidateDetails>(
    defaultValue.candidateData
  );
  const [candidateCategory, setCandidateCategory] = useState<CandidateCategory>(
    defaultValue.candidateCategory
  );

  return (
    <CandidateContext.Provider
      value={{
        candidateData,
        setCandidateData,
        candidateCategory,
        setCandidateCategory,
      }}
    >
      {children}
    </CandidateContext.Provider>
  );
};
